import { Col, Row } from "antd";
import useCapitalize from "apps/Common/Adress/helpers/useCapitalize";
import PageTitle from "apps/Common/PageTitle";
import CategoryBreadCrumb from "./CategoryBreadcrumb";

const AdTitle = (props: any) => {
  const { capitalize } = useCapitalize();
  const title = capitalize(props.advertDetails?.data?.data?.title);
  const isLongTitle = title?.length > 25;

  return (
    <Row
      gutter={[
        { xs: 10, lg: 10 },
        { xs: 5, lg: 10 },
      ]}
      className="!w-full"
    >
      <Col xs={24} sm={18} lg={24} className="!flex justify-center sm:justify-start lg:!block">
        <PageTitle
          title={title}
          textClassNames={isLongTitle ? "!text-[20px]" : ""}
        />
      </Col>
      <Col
        xs={24}
        sm={6}
        className="!flex sm:!flex items-center justify-center sm:justify-end !w-full lg:!hidden"
      >
        <CategoryBreadCrumb />
      </Col>
    </Row>
  );
};

export default AdTitle;
